/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Anlasskommentarbutschuko4Inputs */

const de__field_anlasskommentarbutschuko4 = /** @type {(inputs: _Field_Anlasskommentarbutschuko4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentar/Info`)
};

/**

* @param {_Field_Anlasskommentarbutschuko4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_anlasskommentarbutschuko4 = /** @type {((inputs?: _Field_Anlasskommentarbutschuko4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Anlasskommentarbutschuko4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_anlasskommentarbutschuko4(inputs)
});
export { _field_anlasskommentarbutschuko4 as "_field_anlassKommentarBuTSchuko" }